import React from 'react';
import { useTranslation } from 'react-i18next';
import { ALL_POSE_KEYS, hasPose } from '../../lib/comparisonSlots';

// Pose ids -> the translation keys BOTH pose pickers already use. Keep in step
// with POSE_LABEL_KEYS in components/share/ComparisonShareDialog.js.
const POSE_LABEL_KEYS = {
  front: 'clientCheckIns.posesFrontRelaxed',
  side: 'clientCheckIns.posesSideRelaxed',
  back: 'clientCheckIns.posesBackRelaxed',
  front_flex: 'clientCheckIns.posesFrontFlex',
  side_flex: 'clientCheckIns.posesSideFlex',
  back_flex: 'clientCheckIns.posesBackFlex',
  relaxed: 'clientCheckIns.posesFavorite',
};

export default function PoseSlotPicker({
  pairCount, onPairCount, slots, onSlots, beforeCheckIn, afterCheckIn,
}) {
  const { t } = useTranslation();
  const set = (key, value) => onSlots({ ...slots, [key]: value });

  const rows = pairCount === 2
    ? [
        { n: 1, beforeKey: 'r1b', afterKey: 'r1a' },
        { n: 2, beforeKey: 'r2b', afterKey: 'r2a' },
      ]
    : [];

  return (
    <div className="space-y-2">
      <div className="inline-flex rounded-lg bg-muted p-0.5">
        {[
          { n: 1, label: t('photoCompare.twoPhotos', '2 photos') },
          { n: 2, label: t('photoCompare.fourPhotos', '4 photos') },
        ].map(({ n, label }) => (
          <button key={n} type="button" onClick={() => onPairCount(n)}
            aria-pressed={pairCount === n}
            className={`px-3 h-11 md:h-8 text-xs rounded-md transition-colors ${
              pairCount === n ? 'bg-background shadow text-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}>
            {label}
          </button>
        ))}
      </div>

      {rows.map(({ n, beforeKey, afterKey }) => (
        <div key={n} className="grid grid-cols-2 gap-2">
          <PoseSelect
            label={t('photoCompare.rowBefore', { defaultValue: 'Row {{n}} before', n })}
            value={slots[beforeKey]} onChange={(v) => set(beforeKey, v)}
            checkIn={beforeCheckIn} t={t}
          />
          <PoseSelect
            label={t('photoCompare.rowAfter', { defaultValue: 'Row {{n}} after', n })}
            value={slots[afterKey]} onChange={(v) => set(afterKey, v)}
            checkIn={afterCheckIn} t={t}
          />
        </div>
      ))}
    </div>
  );
}

function PoseSelect({ label, value, onChange, checkIn, t }) {
  return (
    <label className="block">
      <span className="sr-only">{label}</span>
      <select
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-11 md:h-8 rounded-md border border-input bg-background px-2 text-xs"
      >
        {ALL_POSE_KEYS.map((p) => (
          <option key={p} value={p} disabled={!hasPose(checkIn, p)}>
            {t(POSE_LABEL_KEYS[p])}
          </option>
        ))}
      </select>
    </label>
  );
}
